import React, { useEffect, useRef, useState } from "react";
import "./UiButtons.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { usePopup } from "src/contexts/PopupContext";
import { useLoader } from "src/contexts/LoaderContext";
import { Tooltip, TooltipRefProps } from "react-tooltip";
import { useView } from "src/contexts/ViewContext";

const AddToCartIcon: React.FC = () => {
  return (
      <svg width="27" height="26" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_2181_8698)"><path d="M14.461 5.33333C14.1283 2.338 11.5837 0 8.50033 0C5.417 0 2.87233 2.338 2.53966 5.33333H0.486328L1.76499 14.2833C1.90499 15.262 2.75566 16 3.74499 16H13.2557C14.2443 16 15.0957 15.262 15.2357 14.2833L16.5143 5.33333H14.461ZM8.50033 1.33333C10.8463 1.33333 12.7883 3.076 13.1137 5.33333H3.88699C4.21233 3.076 6.15433 1.33333 8.50033 1.33333ZM5.83366 13.3333H4.50033V8H5.83366V13.3333ZM9.167 13.3333H7.83366V8H9.167V13.3333ZM12.5003 13.3333H11.167V8H12.5003V13.3333Z" fill="currentColor"></path></g><defs><clipPath id="clip0_2181_8698"><rect width="16" height="16" fill="white" transform="translate(0.5)"></rect></clipPath></defs></svg>
  );
};

const SaveOfferIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
    >
      <mask
        id="mask0_745_1019"
        maskUnits="userSpaceOnUse"
        x="0"
        y="16"
        width="26"
        height="11"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.712891 16.5334H25.2872V26.5176H0.712891V16.5334Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_745_1019)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.77194 16.5334C1.18786 16.5334 0.712891 17.0084 0.712891 17.5925V23.1773C0.712891 25.0191 2.21143 26.5176 4.05323 26.5176H21.947C23.7888 26.5176 25.2873 25.0191 25.2873 23.1773V17.5925C25.2873 17.0084 24.8124 16.5334 24.2283 16.5334C23.6442 16.5334 23.1692 17.0084 23.1692 17.5925V23.1773C23.1692 23.851 22.6207 24.3996 21.947 24.3996H4.05323C3.37957 24.3996 2.83098 23.851 2.83098 23.1773V17.5925C2.83098 17.0084 2.35601 16.5334 1.77194 16.5334Z"
          fill="currentColor"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43163 12.201C7.02539 12.201 6.65641 12.4409 6.49144 12.8121C6.32646 13.1833 6.39564 13.6179 6.6675 13.9195L12.2364 20.0902C12.6257 20.5221 13.3748 20.5221 13.7642 20.0902L19.333 13.9195C19.6049 13.6179 19.6741 13.1833 19.5091 12.8121C19.3441 12.4409 18.9751 12.201 18.5689 12.201H14.6498V7.79007C14.6498 6.88048 13.9096 6.14075 13.0005 6.14075C12.0909 6.14075 11.3507 6.88048 11.3507 7.79007V12.201H7.43163Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9994 0.482422C12.0898 0.482422 11.3501 1.22216 11.3501 2.13175V2.39252C11.3501 3.30166 12.0898 4.04184 12.9994 4.04184C13.909 4.04184 14.6487 3.30166 14.6487 2.39252V2.13175C14.6487 1.22216 13.909 0.482422 12.9994 0.482422Z"
        fill="currentColor"
      />
    </svg>
  );
};

const UiButtons: React.FC = () => {
  const { request, uncompletedTabs } = useConfiguration();
  const {
    setIsSaveOfferFormVisible,
    setResultPopupText,
    setIsResultPopupVisible,
    setSaveOfferMode,
  } = usePopup();
  const {
    setIsMainLoaderVisible,
    setMainLoaderText,
    setIsWhiteSceneLoaderVisible,
  } = useLoader();
  const { isAdmin } = useView();

  const tooltips = {
    1: useRef<TooltipRefProps>(null),
    2: useRef<TooltipRefProps>(null),
    3: useRef<TooltipRefProps>(null),
    4: useRef<TooltipRefProps>(null),
    5: useRef<TooltipRefProps>(null),
    6: useRef<TooltipRefProps>(null),
  };

  const showTooltips = () => {
    uncompletedTabs.forEach((id: number) => {
      // @ts-ignore
      tooltips[id].current?.open({
        anchorSelect: `#tab-number-${id}`,
      });
    });

    setTimeout(() => {
      uncompletedTabs.forEach((id: number) => {
        // @ts-ignore
        tooltips[id].current?.close();
      });
    }, 3000);
  };

  const addOrder = async () => {
    // if (!isAdmin() && uncompletedTabs.size > 0) {
    //     showTooltips();
    //     return;
    // }

    setIsWhiteSceneLoaderVisible(true);
    setMainLoaderText(
      "Werk in uitvoering. We plaatsen uw overkapping nu in de winkelwagen."
    );
    setIsMainLoaderVisible(true);

    try {
      await request.addOrder();
    } catch (error) {
      console.error("Error adding order:", error);
      setIsMainLoaderVisible(false);
      setIsWhiteSceneLoaderVisible(false);
      setResultPopupText("Er is iets misgegaan. Probeer het later opnieuw.");
      setIsResultPopupVisible(true);
    }
  };

  const handleOpenForm = (mode: "offer" | "purchase") => {
    setSaveOfferMode(mode);
    setIsSaveOfferFormVisible(true);
  };

  return (
    <>
      <div className={"ui-buttons"}>
        {/* <button className="add-to-cart-button" onClick={addOrder}>
          <AddToCartIcon />
          <span>In winkelwagen</span>
        </button> */}
        <button
          // className="save-offer-button"
          className="offer-button"
          onClick={() => handleOpenForm("offer")}
        >
          <SaveOfferIcon />
          <span>Overkapping opslaan</span>
        </button>
        <button
          className="add-to-cart-button"
          onClick={() => handleOpenForm("purchase")}
        >
          <AddToCartIcon />
          <span>Ik wil bestellen</span>
        </button>
      </div>
      <Tooltip
        ref={tooltips[1]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[2]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[3]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[4]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[5]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[6]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
    </>
  );
};

export default UiButtons;
